import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faEnvelope,
  faUnlockAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faGithub,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  FormCheck,
  Container,
  InputGroup,
  Spinner,
} from "@themesberg/react-bootstrap";
import { Link, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

import { Routes } from "../../routes";
import BgImage from "../../assets/img/illustrations/signin.svg";
import { signin } from "../../redux/actions/auth";

import Preloader from "../../components/Preloader";

import MainLogo from "../../assets/img/brand/LOGO.png";
import NepaliLogo from "../../assets/img/brand/Logo-nepali.png";
import CustomToast from "../../components/CustomToast";

export default ({ history }) => {
  const userState = useSelector((state) => state.user);
  const initialLoading = userState.initialLoading;

  const dispatch = useDispatch();
  const [values, setValues] = useState({
    username: "",
    password: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSuccess = () => {
    history.push("/dashboard/overview");
    CustomToast({
      position: "bottom-right",
      title: "Login Successfull! Welcome back",
      toastType: "success",
      duration: 4000,
    });
    setSubmitting(false);

    // alert("Success logged in");
  };
  const handleFaliure = (e) => {
    // alert("Login failed");
    toast.error(e.response ? e.response.data.message : e.message);
    setSubmitting(false);
  };

  const loginHandler = (e) => {
    e.preventDefault();
    setSubmitting(true);
    dispatch(signin(values, handleSuccess, handleFaliure));

    // history.push("/dashboard/overview");
  };
  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  return (
    <main>
      {initialLoading === true && <Preloader show={true} />}
      {userState.userData !== null && <Redirect to="/dashboard/overview" />}
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          {/* <Row className="justify-content-center form-bg-image" style={{ backgroundImage: `url(${BgImage})` }}> */}
          <Row className="justify-content-center form-bg-image">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  {/* <h3 className="mb-0">Sign in Mero Sahakari</h3> */}
                  {/* <img
                      src={NepaliLogo}
                      alt="Nepali-Logo"
                      className="sign-logo"
                    /> */}
                  <img src={MainLogo} alt="Logo" className="sign-logo" />
                </div>
                <Form className="mt-4" onSubmit={loginHandler}>
                  <Form.Group id="username" className="mb-4">
                    <Form.Label>Your Username</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="text"
                        placeholder="Enter your username"
                        name="username"
                        onChange={onChange}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Your Password</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type="password"
                          placeholder="Password"
                          name="password"
                          onChange={onChange}
                        />
                      </InputGroup>
                    </Form.Group>
                    {/* <div className="d-flex justify-content-between align-items-center mb-4">
                      <Form.Check type="checkbox">
                        <FormCheck.Input id="defaultCheck5" className="me-2" />
                        <FormCheck.Label htmlFor="defaultCheck5" className="mb-0">Remember me</FormCheck.Label>
                      </Form.Check>
                      <Card.Link className="small text-end">Lost password?</Card.Link>
                    </div> */}
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    disabled={submitting}
                  >
                    {submitting === true ? (
                      <Spinner animation="border" />
                    ) : (
                      "Sign in"
                    )}
                    {/* {submitting === true && } */}
                  </Button>
                </Form>

                {/* <div className="mt-3 mb-4 text-center">
                  <span className="fw-normal">or login with</span>
                </div> */}
                {/* <div className="d-flex justify-content-center my-4">
                  <Button variant="outline-light" className="btn-icon-only btn-pill text-facebook me-2">
                    <FontAwesomeIcon icon={faFacebookF} />
                  </Button>
                  <Button variant="outline-light" className="btn-icon-only btn-pill text-twitter me-2">
                    <FontAwesomeIcon icon={faTwitter} />
                  </Button>
                  <Button variant="outline-light" className="btn-icon-only btn-pil text-dark">
                    <FontAwesomeIcon icon={faGithub} />
                  </Button>
                </div> */}
                {/* <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    Not registered?
                    <Card.Link as={Link} to={Routes.Signup.path} className="fw-bold">
                      {` Create account `}
                    </Card.Link>
                  </span>
                </div> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
